// extracted by mini-css-extract-plugin
export var carrierTab = "_4o-0";
export var carrierTabActive = "_4o-1 _4o-0";
export var carrierTabInactive = "_4o-2 _4o-0";
export var carrierTabLabel = "_4o-3";
export var carrierTabLabelActive = "_4o-4 _4o-3";
export var carrierTabLabelInactive = "_4o-5 _4o-3";
export var carrierTabPercentage = "_4o-6";
export var carrierTabPercentageActive = "_4o-7 _4o-6";
export var carrierTabPercentageInactive = "_4o-8 _4o-6";
export var carrierTabWinnable = "_4o-9";
export var carrierTabWinnableActive = "_4o-a _4o-9";
export var carrierTabWinnableInactive = "_4o-b _4o-9";
export var comparisonContainer = "_4o-d";
export var missingRateButton = "_4o-n";
export var missingRateButtonActive = "_4o-o _4o-n";
export var missingRateButtonInactive = "_4o-p _4o-n";
export var missingRateButtonLabel = "_4o-q";
export var missingRateButtonLabelActive = "_4o-r _4o-q";
export var missingRateButtonLabelInactive = "_4o-s _4o-q";
export var sidebar = "_4o-c";
export var strategyButton = "_4o-e";
export var strategyButtonActive = "_4o-f _4o-e";
export var strategyButtonDescription = "_4o-k";
export var strategyButtonDescriptionActive = "_4o-l _4o-k";
export var strategyButtonDescriptionInactive = "_4o-m _4o-k";
export var strategyButtonInactive = "_4o-g _4o-e";
export var strategyButtonLabel = "_4o-h";
export var strategyButtonLabelActive = "_4o-i _4o-h";
export var strategyButtonLabelInactive = "_4o-j _4o-h";
export var unitToggleButton = "_4o-t";
export var unitToggleButtonActive = "_4o-u _4o-t";
export var unitToggleButtonInactive = "_4o-v _4o-t";
export var unitToggleButtonLabel = "_4o-w";
export var unitToggleButtonLabelActive = "_4o-x _4o-w";
export var unitToggleButtonLabelInactive = "_4o-y _4o-w";